module.exports = __webpack_public_path__ + "img/cart.d8a19333.svg";